import { createContext, useContext } from "react";

/** What a page may ask of the shell (redesign spec §4.5, §4.6). */
export type Shell = {
  /** Opens the rail and the column as a drawer. Only phones show the button for it. */
  openMenu: () => void;
  /** Opens the search dialog, which the shell mounts once. */
  openSearch: () => void;
};

const noop = () => {};

/** Outside the shell (a page rendered alone in a test) both are no-ops. */
export const ShellContext = createContext<Shell>({ openMenu: noop, openSearch: noop });

export const useShell = (): Shell => useContext(ShellContext);
